<script setup lang="ts">
import { marked } from "marked";

import rgaa from "../../criteres.json";
import { CriteriumResultStatus } from "../../types";
import { formatStatus, isTiptapDocumentEmpty } from "../../utils";
import TiptapRenderer from "../tiptap/TiptapRenderer.vue";

defineProps<{
  topic: number;
  criterium: number;
  comment: string;
  status: CriteriumResultStatus;
}>();

function getCriterium(topicNumber: number, criteriumNumber: number) {
  // FIXME: "any everywhere" : The criteria properties of each topic do not have the same signature. See: https://github.com/microsoft/TypeScript/issues/33591#issuecomment-786443978
  const criterium = (rgaa.topics as any)
    .find((t: any) => t.number === topicNumber)
    ?.criteria.find(
      (c: any) => c.criterium.number === criteriumNumber
    ).criterium;

  return criterium;
}

function getCriteriumTitle(topicNumber: number, criteriumNumber: number) {
  return marked.parseInline(getCriterium(topicNumber, criteriumNumber).title);
}
</script>

<template>
  <div>
    <p class="fr-text--lg fr-text--bold criterium-title fr-mb-2w">
      {{ topic }}.{{ criterium }}&nbsp;–
      <span v-html="getCriteriumTitle(topic, criterium)" />
    </p>

    <p
      class="fr-badge fr-badge--sm fr-badge--no-icon fr-mb-3w"
      :class="
        status === CriteriumResultStatus.COMPLIANT
          ? 'fr-badge--success'
          : undefined
      "
    >
      {{ formatStatus(status) }}
    </p>

    <TiptapRenderer
      v-if="comment && !isTiptapDocumentEmpty(comment)"
      :document="comment"
    />
  </div>
</template>
